import { render, staticRenderFns } from "./MergeMember.vue?vue&type=template&id=3021dcc6"
import script from "./MergeMember.vue?vue&type=script&lang=js"
export * from "./MergeMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports